import PanelBox from '../../components/PanelBox';
import React, { Component } from 'react'
import { connect } from "react-redux";
import { Progress, message, Spin, Form, Input, Icon, Row, Col, Button, Upload } from 'antd';

import { API_CREATE_JOB, API_CREATE_JOB_LINK, API_JOB_UPLOAD_COMPLETE } from '../../config';
import { switch_api } from '../../actions/switch_api';

import ReactDropZone from 'react-dropzone';

const FormItem = Form.Item;
// const Dragger = Upload.Dragger;

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}


class CaseUploadCT extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      fileUploadLinks: [],
      fileLoaded: 0,
      fileProgress: 0,
      fileUploading: false,
      patient_id: null,
      complieted_dict: {},
      showFileList: false
    };
    this.tryToUpload = this.tryToUpload.bind(this)

    this.createJob = this.createJob.bind(this)
    this.uploadCompliete = this.uploadCompliete.bind(this)
    this.createUploadLink = this.createUploadLink.bind(this)

    this.sendToSpace = this.sendToSpace.bind(this)

    this.setPatientId = this.setPatientId.bind(this)

    this.incProgress = this.incProgress.bind(this)

    this.toggleShowFileList = this.toggleShowFileList.bind(this)
  }

  tryToUpload() {
    this.setState({fileUploading:true})
    this.createJob()
  }

  //TODO: Move to action/jobs
  createJob() {
    let token =  localStorage.getItem('token')
    fetch(switch_api(API_CREATE_JOB), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
      body: JSON.stringify({
        'patient_tag': this.state.patient_id,
        'flow': this.props.user.flow.filter((elm) => (elm.type === 'ct_align'))[0].uuid
      })
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_CREATE_LINK }: " + response.statusText);
      }
      return response;
    })
    .then((json) => {
      let fileList = []
      this.state.fileList.forEach((file) => {
        fileList.push(file.name)
      });
      this.createUploadLink(fileList)
    })
  }


  createUploadLink(fileList) {
    let token =  localStorage.getItem('token')
    fetch(switch_api(API_CREATE_JOB_LINK), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
      body: JSON.stringify(fileList)
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_CREATE_LINK }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((json) => this.sendToSpace(json))
    .catch((e) => {
      console.warn(e)
    })
  }

  uploadCompliete() {
    let token =  localStorage.getItem('token')
    fetch(switch_api(API_JOB_UPLOAD_COMPLETE), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
    })
  }


  sendToSpace(fileUploadLinks) {
    let ComplietedDict = {}
    if (fileUploadLinks) {
      this.state.fileList.forEach((file) => {
        // fileUploadLinks.map((link_item)=>link_item.filename == file.name ? this.sendFile(link_item.link,file) : null)
        fileUploadLinks.map((link_item)=>link_item.filename == file.name ? ComplietedDict[link_item.filename]={'link':link_item.link,'file':file} : null)
      });
    }

    this.setState({'complieted_dict':ComplietedDict})
    this.sendFile()
  }

  incProgress() {
    if (this.state.fileProgress != this.state.fileList.length) {
      this.setState({fileProgress:this.state.fileProgress+1})
      this.sendFile()
    }
  }

  sendFile() {
    let fileList = this.state.complieted_dict
    if (Object.keys(fileList).length) {
      let fileItem = Object.keys(fileList)[0]
      let URL = fileList[fileItem]['link']
      let file = fileList[fileItem]['file']
      let blob = new Blob([file], {type: file.type});
      fetch(URL, {
        method: 'PUT',
        body: blob
      })
      .then((response) => {
        if (!response.ok) {
          console.error("Failed loading { API_CREATE_LINK }: " + response.statusText);
          message.error('Upload Failed');
        }
        return response;
      })
      // .then((response) => console.warn(response))
      .then(()=>{
        delete fileList[fileItem]
        this.setState({complieted_dict:fileList})
        this.incProgress()

        if (this.state.fileProgress == this.state.fileList.length) {
          this.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null})
          message.success('Files has been uploaded!');
          this.uploadCompliete()
          this.props.history.push('/home')
        }
      })
      .catch((e) => {
        console.warn(e)
        message.error('Upload Failed');
        this.setState({fileUploading:false,fileProgress:0})
      })
    }
  }

  setPatientId(data) {
    this.setState({'patient_id':data})
  }

  toggleShowFileList() {
    this.setState({showFileList:!this.state.showFileList})
  }

  render() {

    const formPatientField = {
      labelCol: { span: 10 },
      wrapperCol: { span: 6 },
    };

    const formItemFiels = {
      labelCol: { span: 10 },
      wrapperCol: { span: 24 },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 14,
          offset: 0,
        },
        sm: {
          span: 14,
          offset: 10,
        },
      },
    };
    let uploadProgress = Math.round(this.state.fileProgress*100/this.state.fileList.length)
    return (
      <PanelBox title={"Case Upload"}>
        <Row type="flex" justify="center">
          <FormItem
            {...formPatientField}
            label="Patient id"
            hasFeedback
          >
            <Input
              prefix={<Icon type="user" style={{ fontSize: 13 }} />}
              id="patient-id-input"
              value={this.state.patient_id ? this.state.patient_id : ""}
              onChange={(e) => this.setPatientId(e.target.value)}
              disabled={this.state.fileUploading}
              style={{ width: 100 }}/>
          </FormItem>
        </Row>
        <Row type="flex" justify="center">
          <FormItem {...formItemFiels}>
          <ReactDropZone
              accept={[ '.zip', '.obj' ]}
              id="zipped-ct-dropzone"
              onDrop={(e) => {
                this.setState(({ fileList }) => {
                  return {
                    fileList: e.map((elm, i) => {
                      elm.uid = i;
                      return elm;
                    })
                  };
                });
              }}
              style={{
                border: '1px dashed #d9d9d9',
                transition: 'border-color 0.3s',
                cursor: 'pointer',
                borderRadius: '4px',
                textAlign: 'center',
                width: '100%',
                height: '100%',
                position: 'relative',
                padding: '16px 0',
                background: '#fafafa'
              }}
            >
              <p className="ant-upload-drag-icon">
                <Icon type="inbox" />
              </p>
              <p className="ant-upload-text" style={{margin: 10}}>Click or drag file to this area to upload</p>
            </ReactDropZone>
            {/* <Dragger
              accept={".dcm,.dicom"}
              disabled={this.state.fileUploading}
              multiple
              processData={false}
              // fileList={this.state.fileList}

              beforeUpload = {(file) => {
                this.setState(({ fileList }) => ({
                  fileList: [...fileList, file],
                }));
                return false;
              }}
            >
              <p className="ant-upload-drag-icon">
                <Icon type="inbox" />
              </p>
              <p className="ant-upload-text" style={{margin: 10}}>Click or drag file to this area to upload</p>
            </Dragger> */}
            { this.state.fileList.length ?
              <div className={'ant-upload-list-box'}>
                <div style={{'cursor':'pointer', display:'flex', justifyContent: 'space-between', alignItems: 'center', margin: 10}}onClick={()=>this.toggleShowFileList()}>
                  <div>
                    <Icon type="copy" style={{margin: 5}}/>
                      files ({this.state.fileList.length})
                    </div>
                  { <Icon type={this.state.showFileList ? "caret-down" : "caret-right" }/> }
                </div>
                {this.state.showFileList && <Upload fileList={this.state.fileList}
                                                    onRemove = {(file) => {
                                                      this.setState(({ fileList }) => {
                                                        const index = fileList.indexOf(file);
                                                        const newFileList = fileList.slice();
                                                        newFileList.splice(index, 1);
                                                        return {
                                                          fileList: newFileList,
                                                        };
                                                      });
                                                    }}></Upload>}
              </div> : null }
            { Boolean(uploadProgress) ? <Progress percent={uploadProgress} strokeWidth={5} /> : null}
          </FormItem>
        </Row>
        <Row type="flex" justify="center">
          <Button
            loading={this.state.fileUploading}
            className="upload-demo-start"
            id="submit-new-case-button"
            type="primary"
            onClick={this.tryToUpload}
            disabled={this.state.fileList.length && this.state.patient_id ? false : true}
          >
            Start Upload
          </Button>
        </Row>
      </PanelBox>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseUploadCT)


// WEBPACK FOOTER //
// ./src/views/Cases/caseUploadCTAlign.jsx